import { BorderStyle, Colors } from '@factorialco/deprecated-design-system'

import { ContractSchedule } from 'modules/contracts/lib/contractSchedule'

interface Return {
  background: Colors
  borderStyle: BorderStyle['style']
  borderColor: BorderStyle['color']
}

const getContractVersionStyles = (
  contractSchedule: string,
  isHovered = false,
  isHighlighted = false
): Return => {
  let background: Colors = isHovered ? 'grey100' : 'grey000White'
  let borderColor: BorderStyle['color'] = 'grey400'

  if (isHighlighted) {
    switch (contractSchedule) {
      case ContractSchedule.expired:
        background = 'grey200'
        borderColor = 'grey800'
        break
      case ContractSchedule.ongoing:
        background = 'viridian100'
        borderColor = 'viridian1200'
        break
      case ContractSchedule.upcoming:
        background = 'champagne100'
        borderColor = 'champagne1000'
        break
    }
  }
  const borderStyle = contractSchedule === ContractSchedule.upcoming ? 'dashed' : 'solid'

  return {
    background,
    borderStyle,
    borderColor,
  }
}

export default getContractVersionStyles
